import styled from "styled-components";

export const SearchFieldParentContainer = styled.form`
  height: 50px;
  & ~ .searchBtn404 {
    border-radius: ${({ theme }) =>
      theme.isRTL ? `8px 0 0 8px` : `0 8px 8px 0`};
    width: ${({ theme }) => (theme.isMobile ? `25%` : `268px`)};
  }
`;

export const SearchFieldTextContainer = styled.input`
  padding: 10px;
  border: 1px solid #000;
  ${({ theme }) => (theme.isRTL ? `border-left:0` : `border-right:0`)};
  border-radius: ${({ theme }) =>
    theme.isRTL ? `0 8px 8px 0` : `8px 0 0 8px`};
  height: 50px;

  :focus {
    border: 2px solid #1976d2;
  }
`;
